<template>
	<div :class="{ active }" class="collapse border-dashed-bottom">
		<div class="collapse-header" @click="toggle">
			<div class="h3">
				{{ title }}
			</div>
			<div class="collapse-toggle-icon" />
		</div>
		<div class="collapse-body">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'Collapse',
	props: {
		title: {
			type: String,
			default: ''
		},
		opened: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({ active: false }),
	watch: {
		opened: {
			immediate: true,
			handler (value) {
				this.active = value
			}
		}
	},
	methods: {
		toggle () {
			this.active = !this.active
			this.$emit('change', this.active)
		}
	}
}
</script>

<style lang="scss">
	.collapse {
		position: relative;
		margin: 32px 0;

		&.active {
			.collapse-toggle-icon {
				transform: translateY(-50%);
			}

			.collapse-body {
				opacity: 1;
				height: auto;
				padding: 32px 0;
				pointer-events: auto;
			}
		}

		.collapse-header {
			position: relative;
			padding: 25px 0;
			cursor: pointer;
		}

		.collapse-body {
			transition: 0.6s all;
			pointer-events: none;
			height: 0;
			opacity: 0;
		}

		.collapse-toggle-icon {
			position: absolute;
			top: 50%;
			right: 25px;
			transform: translateY(-50%) rotate(90deg);
			width: 0;
			height: 0;
			cursor: pointer;
			transition: 0.3s transform;
			border-top: 15px solid $primary;
			border-left: 15px solid transparent;
			border-right: 15px solid transparent;
		}
	}
</style>
